import { getAuthHeaders, getCurrentUser } from "./authService";

const domain = process.env.REACT_APP_DOMAIN 

export async function fetchUsersByRole(role, { page = 1, limit = 5, search = "" } = {}) {
  const params = new URLSearchParams();
  if (role) params.set("role", role);
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (search) params.set("search", search);

  const response = await fetch(`${domain}/api/v1/user/get/all?${params.toString()}`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  const data = await response.json();
  return data;
}

export const fetchUsersByIds = async (ids) => {
  if (!ids || !ids.length) return [];
  try {
    const res = await fetch(`${domain}/api/v1/user/by-ids`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({ ids }),
    });
    const data = await res.json();

    if (data.success) return data.users;
    // console.log(data.users);

    return [];
  } catch (err) {
    return [];
  }
};

export const updateTeamMember = async (memberId, updateData) => {
  const response = await fetch(`${domain}/api/v1/user/update/${memberId}`, {
    method: "PUT",
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updateData),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Failed to update team member");
  }

  const updatedUser = data.user || data.data || data;

  return {
    ...updateData,
    ...updatedUser,
  };
};

export const DeleteTeamMember = async (memberId) => {
  const response = await fetch(`${domain}/api/v1/user/delete/${memberId}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Failed to delete team member");
  }

  return { success: true, data };
};
